import React from "react";
import { 
  Row, 
  Col, 
  Card, 
  Typography, 
  Dropdown, 
  Button, 
  Tag, 
  Collapse, 
  Space,
  Divider
} from "antd";
import "../styles/components/client-interface.css";
import {
  GlobalOutlined,
  ApartmentOutlined,
  UserOutlined,
  InfoCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { IoBusinessSharp } from "react-icons/io5";
import { FaMobileAlt } from "react-icons/fa";
import { MdComputer } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { GiBus } from "react-icons/gi";
import { GiBusStop } from "react-icons/gi";
import { HiOutlineTicket } from "react-icons/hi2";
import { Tree } from "antd";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { DirectoryTree } = Tree;

export const Legend = () => (
  <Row
    className="legend-container"
    align={"middle"}
    justify={"center"}
    gutter={[25]}
  >
    <Col className="legend-item">
      <div className="legend-dot legend-dot-current"></div>{" "}
      <span>selezione corrente</span>
    </Col>
    <Col className="legend-item">
      <div className="legend-dot legend-dot-company"></div>{" "}
      <span>altro dato azienda</span>
    </Col>
    <Col className="legend-item">
      <div className="legend-dot legend-dot-third-party"></div>{" "}
      <span>dato azienda terza</span>
    </Col>
    <Col className="legend-item">
      <div 
        className="legend-dot" 
        style={{
          background: "repeating-linear-gradient(45deg, transparent, transparent 3px, white 3px, white 6px), #b5b4b3"
        }}
      ></div>{" "}
      <span>dato azienda terza (non confrontabile)</span>
    </Col>
    <Col className="legend-item">
      <div 
        className="legend-dot" 
        style={{
          background: "repeating-linear-gradient(45deg, transparent, transparent 3px, white 3px, white 6px), #fc6d00"
        }}
      ></div>{" "}
      <span>Selezione corrente (dato non confrontabile)</span>
    </Col>
    <Col className="legend-item">
      <div 
        style={{
          width: 20,
          height: 2,
          background: "repeating-linear-gradient(90deg, green 0px, green 4px, transparent 4px, transparent 8px)",
          borderRadius: 1,
        }}
      ></div>{" "}
      <span>Media</span>
    </Col>
  </Row>
);

export const LegendComparable = () => (
  <Row
    className="comparable-legend-container"
    align={"middle"}
    justify={"center"}
    gutter={[25]}
  >
    <Col className="comparable-legend-item">
      <div className="legend-dot legend-dot-current"></div>{" "}
      <span>selezione corrente</span>
    </Col>

    <Col className="comparable-legend-item">
      <div className="legend-dot legend-dot-third-party"></div>{" "}
      <span>dato azienda terza</span>
    </Col>
    <Col className="comparable-legend-item">
      <div 
        style={{
          width: 20,
          height: 2,
          background: "repeating-linear-gradient(90deg, green 0px, green 4px, transparent 4px, transparent 8px)",
          borderRadius: 1,
        }}
      ></div>{" "}
      <span>Media</span>
    </Col>
  </Row>
);

export const RenderIcons = ({ chartLevel, chartHistory }) => (
  <>
    {chartLevel === 0 && (
      <GlobalOutlined className="chart-icon" style={{ fontSize: "40px" }} />
    )}
    {chartLevel === 1 && (
      <IoBusinessSharp className="chart-icon" style={{ fontSize: "40px" }} />
    )}
    {chartLevel === 2 && (
      <IoBusinessSharp className="chart-icon" style={{ fontSize: "40px" }} />
    )}
    {chartLevel === 3 && (
      <FaMobileAlt className="chart-icon" style={{ fontSize: "40px" }} />
    )}
    {chartLevel === 4 && (
      <MdComputer className="chart-icon" style={{ fontSize: "40px" }} />
    )}
    {chartLevel === 5 && (
      <FaPhoneAlt className="chart-icon" style={{ fontSize: "30px" }} />
    )}
    {((chartLevel === 6 &&
      chartHistory[chartHistory.length - 1]?.data?.category ==
        "Linee.URBANO") ||
      chartHistory[chartHistory.length - 1]?.data?.category ==
        "Linee.EXTRAURBANO") && (
      <GiBus className="chart-icon" style={{ fontSize: "40px" }} />
    )}
    {chartLevel === 6 &&
      chartHistory[chartHistory.length - 1]?.data?.category == "Fermate" && (
        <GiBusStop className="chart-icon" style={{ fontSize: "40px" }} />
      )}
    {chartLevel === 6 &&
      chartHistory[chartHistory.length - 1]?.data?.category ==
        "Punti Vendita" && (
        <HiOutlineTicket className="chart-icon" style={{ fontSize: "40px" }} />
      )}
  </>
);

export const TourButton = ({ setTourOpen }) => (
  <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16, gap: 25 }}>
    <Button
      type="primary"
      className="tour-button"
      onClick={() => setTourOpen(true)}
    >
      Guida interattiva
    </Button>
  </div>
);

export const WelcomeCard = ({ userData, allClientsData, selectedClient, setSelectedClient, versions, currentVersion, setCurrentVersion }) => (
  <Card
    className="welcome-card"
    bordered={false}
    bodyStyle={{
      padding: 0,
      background: "transparent",
    }}
  >
    {/* Decorative background elements */}
    <div
      style={{
        position: "absolute",
        top: -50,
        right: -50,
        width: 150,
        height: 150,
        background: "rgba(255, 255, 255, 0.1)",
        borderRadius: "50%",
        opacity: 0.6,
      }}
    />
    <div
      style={{
        position: "absolute",
        bottom: -30,
        left: -30,
        width: 100,
        height: 100,
        background: "rgba(255, 255, 255, 0.08)",
        borderRadius: "50%",
      }}
    />

    <Row
      gutter={[16, 16]}
      align="middle"
      justify="space-between"
      style={{
        padding: "32px 24px",
        position: "relative",
        zIndex: 1,
      }}
    >
      <Col xs={24} sm={18} md={20}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <div
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              borderRadius: "50%",
              padding: "12px",
              marginRight: "16px",
              backdropFilter: "blur(10px)",
            }}
          >
            <UserOutlined
              style={{
                fontSize: 24,
                color: "#fff",
              }}
            />
          </div>
          <div>
            <Title
              level={3}
              className="welcome-title"
            >
              Benvenuto
            </Title>
            <Text
              className="welcome-subtitle"
            >
              {userData?.first_name} {userData?.last_name}
            </Text>
          </div>
        </div>

        <div
          style={{
            background: "rgba(255, 255, 255, 0.15)",
            borderRadius: 12,
            padding: "16px 20px",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <Text
            style={{
              fontSize: "1rem",
              color: "rgba(255, 255, 255, 0.95)",
              lineHeight: 1.5,
            }}
          >
            Sei connesso come membro di{" "}
            {userData?.is_admin ? (
              <Dropdown
                type="primary"
                menu={{
                  items: Object.keys(allClientsData).map((client) => ({
                    key: client,
                    label: client,
                  })),
                  onClick: (e) => setSelectedClient(e.key),
                }}
              >
                <Button type="primary">{selectedClient}</Button>
              </Dropdown>
            ) : (
              <Text
                className="welcome-subtitle"
                style={{ fontSize: "1.05rem", fontWeight: 600 }}
              >
                {userData?.company}
              </Text>
            )}
          </Text>
          <div style={{ marginTop: 16 }}>
            <h3
              style={{ color: "#fff", marginTop: 16, fontSize: "1.2rem" }}
            >
              Versioni disponibili:
            </h3>
            {versions.map((version) => {
              return (
                <Tag
                  style={{ cursor: "pointer" }}
                  color={currentVersion == version.version ? "blue" : ""}
                  onClick={() => setCurrentVersion(version.version)}
                  key={version.version}
                >
                  {" "}
                  {version.version}{" "}
                </Tag>
              );
            })}
          </div>
        </div>
      </Col>
    </Row>

    {/* Subtle animation wave effect */}
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.3) 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 3s ease-in-out infinite",
      }}
    />

    <style jsx>{`
      @keyframes shimmer {
        0% {
          background-position: -200% 0;
        }
        100% {
          background-position: 200% 0;
        }
      }
    `}</style>
  </Card>
);

export const CompanyDataPanel = ({ treePanelRef, treeRef, treeData, userData }) => (
  <Collapse
    ref={treePanelRef}
    defaultActiveKey={[]}
    className="info-collapse"
    style={{ marginBottom: 24 }}
  >
    <Panel
      header={
        <span>
          <ApartmentOutlined style={{ marginRight: 8 }} />
          Panoramica Dati Aziendali
        </span>
      }
      key="1"
    >
      <div>
        {treeData.length ? (
          <div ref={treeRef}>
            <DirectoryTree
              multiple
              defaultExpandAll={false}
              treeData={treeData}
              className="data-tree-container"
              style={{ fontSize: 15 }}
            />
          </div>
        ) : (
          <Space>
            <InfoCircleOutlined style={{ color: "#faad14" }} />
            <Text>Nessun dato disponibile per {userData?.company}</Text>
          </Space>
        )}
      </div>
    </Panel>
  </Collapse>
);

export const MainChartCard = ({ 
  chartLevel, 
  chartHistory, 
  getCurrentChartTitle, 
  goBack, 
  resetToRoot, 
  mainChartRef, 
  showChart, 
  chartRef, 
  children 
}) => (
  <Card
    title={
      <span className="chart-title">
        <RenderIcons chartLevel={chartLevel} chartHistory={chartHistory} />
        {getCurrentChartTitle()}
      </span>
    }
    className="main-chart-card"
    bordered
    style={{ minHeight: 400 }}
    extra={
      <Space>
        {chartLevel > 0 && (
          <Button className="nav-button-back" icon={<ArrowLeftOutlined />} onClick={goBack}>
            Indietro
          </Button>
        )}
        {chartLevel > 0 && (
          <Button className="nav-button-back" onClick={resetToRoot}>Torna all'inizio</Button>
        )}
      </Space>
    }
  >
    <div ref={mainChartRef}>
      {showChart && (
        <div
          ref={chartRef}
          key={`main-chart-${chartLevel}`}
          className="chart-canvas-container"
          style={{ height: 350 }}
        />
      )}
      {children}
    </div>
  </Card>
);

export const ChartInfoPanel = ({ chartLevel, chartHistory, userData }) => (
  <div className="chart-info-panel">
    <Text className="chart-info-text">
      {chartLevel === 0 && (
        <span>
          💡 Clicca sulla barra della tua azienda (
          {userData?.company}) per esplorare i dati delle città o le
          sezioni App/Sito/Call Center.
          <br />
          💡 Un dato è non confrontabile quando deriva da
          un'indagine non standard, per cui il punteggio non è
          direttamente paragonabile in questa specifica categoria e
          non contribuisce alla media
        </span>
      )}
      {chartLevel === 1 && (
        <span>
          💡 Clicca sulla barra della tua città per visualizzare i
          dettagli delle categorie che contribuiscono al punteggio
          finale.
        </span>
      )}
      {chartLevel === 2 && (
        <span>
          💡 Confronto tra punteggi relativi territorio selezionato
          (arancione), eventuali altri territori coperti
          dall'azienda (arancione chiaro), territori coperti dalle
          altre aziende .
        </span>
      )}
      {chartHistory[chartHistory.length - 1]?.data?.category ==
        "App" && (
        <span>
          📊Questo grafico mostra la "Media Pesata" per la sezione
          "App" di tutti i clienti. Clicca sulla barra della tua
          azienda per vedere i dettagli.
        </span>
      )}
      {chartHistory[chartHistory.length - 1]?.data?.category ==
        "Call Center" && (
        <span>
          📊Questo grafico mostra la "Media Pesata" per la sezione
          "Call Center" di tutti i clienti. Clicca sulla barra della
          tua azienda per vedere i dettagli.
        </span>
      )}
      {chartHistory[chartHistory.length - 1]?.data?.category ==
        "Sito" && (
        <span>
          📊Questo grafico mostra la "Media Pesata" per la sezione
          "Sito" di tutti i clienti. Clicca sulla barra della tua
          azienda per vedere i dettagli.
        </span>
      )}
      {chartLevel == 6 &&
        (chartHistory[chartHistory.length - 1]?.data?.category ==
          "Linee.URBANO" ||
          chartHistory[chartHistory.length - 1]?.data?.category ==
            "Linee.EXTRAURBANO") && (
          <span>
            Comunicazione: presenza di scritte esterne per
            autopromozione (campagna abbonamenti o ridotto impatto
            ambientale)
            <br /> Informazioni: presenza di PMV, sistema
            informativo audio, esposizione linea e destinazione,
            presenza regolamento viaggio
            <br /> Operatività: presenza obliteratrici,
            bigliettazione a bordo, puntualità
          </span>
        )}
    </Text>
  </div>
);